import React from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { ArrayHelpers, DebugPanel } from '@salesperformanceint/e4shared';
import Package from '../../../package.json';
import config from 'config';
import { apiCode, apiConfig } from 'services';
import { loadText } from './../../actions/ui/index.js';

// The Alt+I debug panel (e4shared DebugPanel), fed from the portal's store. Only partners and
// spoofing users see it. GET api-version is partners only for now, so a spoofing user's panel
// shows the API version as unavailable until the API can tell a spoof session apart.
export const DebugHelper = () => {
    const user = useSelector(state => state.user.user);
    const { text } = useSelector(state => state.ui);
    const dispatch = useDispatch();
    const guid = user?.guid;
    const loadApiVersion = React.useCallback(
        () => axios.get(`${config.apiGateway.URL}api-version${apiCode()}`, apiConfig(guid)).then(response => response.data),
        [guid]
    );

    return (
        <DebugPanel
            appName="Portal"
            user={user}
            canView={user?.authority === 'PARTNER' || user?.authority === 'SPOOF'}
            build={config.build}
            packageVersion={Package.version}
            onReloadTranslations={() => dispatch(loadText())}
            translationsLoading={!ArrayHelpers.existsAndHasLength(text)}
            loadApiVersion={loadApiVersion}
        />
    );
};

export default DebugHelper;
